import React, { useEffect, useRef, useState } from 'react'
import { Tab, TabContainer, SecondaryTab, SectionTabContainer } from './TabStyles'
import { useTabContext } from './TabContext'

export const Tabs = ({ fullWidth = false }: { fullWidth?: boolean }) => {
  const { activeTab, setActiveTab, tabs } = useTabContext()
  const containerRef = useRef<HTMLDivElement>(null)
  const [showFade, setShowFade] = useState(false)

  const checkFade = () => {
    const el = containerRef.current
    if (!el) return
    const hasOverflow = el.scrollWidth > el.clientWidth + 1
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1
    setShowFade(hasOverflow && !atEnd)
  }

  useEffect(() => {
    checkFade()
    const el = containerRef.current
    if (!el) return
    el.addEventListener('scroll', checkFade)
    window.addEventListener('resize', checkFade)
    return () => {
      el.removeEventListener('scroll', checkFade)
      window.removeEventListener('resize', checkFade)
    }
  }, [tabs])

  return (
    <TabContainer ref={containerRef} $showFade={showFade}>
      {tabs.map((tab) => (
        <Tab
          fullWidth={fullWidth}
          key={tab}
          active={activeTab === tab}
          onClick={() => setActiveTab(tab)}
          textContent={tab}
        >
          {tab}
        </Tab>
      ))}
    </TabContainer>
  )
}

export const SectionTabs = () => {
  const { activeTab, setActiveTab, tabs } = useTabContext()
  return (
    <SectionTabContainer>
      {tabs.map((tab) => (
        <SecondaryTab
          active={activeTab === tab}
          textContent={tab}
          onClick={() => setActiveTab(tab)}
          key={tab}
        >
          {tab}
        </SecondaryTab>
      ))}
    </SectionTabContainer>
  )
}
